import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Box, Grid, IconButton } from "@mui/material";
import { SaveRounded } from "@mui/icons-material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import DataTable from "../common/DataTable";
import CustomTextField from "../common/CustomTextField";
import CustomButton from "../common/CustomButton";
import { getCompanyOwnershipType, } from "../../services/CommonServices";

const title = "Ownership Type";

const OwnershipTypes = () => {
    const navigate = useNavigate();
    const [companyOwnershipTypes, setCompanyOwnershipTypes] = useState([]);

    const [formData, setFormData] = useState({
        shortName: "",
        ownershipType: "",
    });

    const columns = useMemo(
        () => [
            { accessorKey: 'id', header: 'SN', size: 50 },
            { accessorKey: 'shortName', header: 'Short Name', size: 150 },
            { accessorKey: 'title', header: 'Ownership Type', size: 200 },
            {
                accessorKey: "action",
                header: "Action",
                size: 50,
                Cell: ({ row }) => (
                    <IconButton onClick={() => handleViewClick(row.original.sn)}>
                        <VisibilityIcon />
                    </IconButton>
                ),
            },
        ],
        []
    );

    const handleViewClick = (id) => {
        navigate(`/app/ownership/${id}`);
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const getOwnershipData = async () => {
        const companyOwnershipData = await getCompanyOwnershipType();
        setCompanyOwnershipTypes(companyOwnershipData);
    };

    useEffect(() => {
        getOwnershipData();
    }, []);

    return (
        <>
            <Box sx={{ paddingLeft: "10px" }} >
                <form>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                            <CustomTextField
                                type="text"
                                name="shortName"
                                fieldLabel="Short Name:"
                                value={formData.shortName}
                                required={true}
                                onChange={handleChange}
                                placeholder="Enter Short Name"
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                            <CustomTextField
                                type="text"
                                name="ownershipType"
                                fieldLabel="Ownership Type:"
                                value={formData.ownershipType}
                                required={true}
                                onChange={handleChange}
                                placeholder="Enter Ownership Type"
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                            <br />
                            <CustomButton
                                startIcon={<SaveRounded />}
                                title="Save"
                                size="small"
                                variant="contained"
                            />
                        </Grid>
                    </Grid>
                </form>
            </Box>
            <Box sx={{ padding: "10px" }}>
                <DataTable
                    title={title}
                    columns={columns}
                    data={companyOwnershipTypes}
                />
            </Box>
        </>
    );
};

export default OwnershipTypes;
